import { Topbar } from '@linearb/linui-common';
import { Outlet } from 'react-router-dom';
import { LoginLoader } from '../../views/login/components/LoginModal/LoginLoader';
import Search from '../../views/root/components/Search';
import { useLoadRootData } from '../../views/root/hooks/useLoadRootData';
import useTopbarDefaultProps from '../../views/root/hooks/useTopbarDefaultProps';
import { useGetDashboardData } from '../../views/root/views/dashboard/hooks/useGetDashboardData';

export function DashboardLayout() {
  useLoadRootData();
  const { isLoading } = useGetDashboardData();
  const topbarProps = useTopbarDefaultProps();

  return (
    <>
      <Topbar
        {...topbarProps}
        container={
          <Search placeholder='Search for automations, actions and repos' />
        }
        beta
        sticky
      />
      {isLoading && <LoginLoader />}
      <Outlet />
    </>
  );
}
